<template>
  <div style="position: relative" class="pl-3">
    <v-row
      class="header-text"
      style="background-color: var(--v-background-base)"
    >
      <v-col cols="12"> {{ title }}</v-col>
    </v-row>

    <v-row no-wrap>
      <v-col
        cols="12"
        class="pa-0"
        style="background-color: var(--v-background-base)"
      >
        <v-sheet
          :width="fixedRowWidth"
          style="background-color: var(--v-background-base)"
        >
          <swiper
            v-if="show"
            class="swiper"
            ref="swipes"
            :options="swiperOptions"
          >
            <swiper-slide
              v-for="(product, index) in products"
              :key="index"
              style="background-color: var(--v-background-base)"
            >
              <Product :product="product" :size="'md'" class="mb-2" />
            </swiper-slide>
            <div
              v-if="$vuetify.breakpoint.smAndUp"
              class="swiper-button-next"
              slot="button-next"
            ></div>
            <div
              v-if="$vuetify.breakpoint.smAndUp"
              class="swiper-button-prev"
              slot="button-prev"
            ></div>
          </swiper>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Product from "@/components/Product/index.vue";
export default {
  name: "RewardProducts",
  components: {
    Product,
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  },
  computed: {
    fixedRowWidth() {
      return this.$vuetify.breakpoint.xsOnly
        ? `${this.innerWidth}px`
        : `${this.innerWidth - 300}px`;
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
  },
  watch: {
    breakpoint() {
      this.swiperOptions.slidesPerView = this.getTabCount();
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  data() {
    return {
      show: true,
      innerWidth: window.innerWidth,
      swiperOptions: {
        slidesPerView: this.getTabCount(),
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    getTabCount() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 3;
        case "sm":
          return 3;
        case "md":
          return 5;
        case "lg":
          return 6;
        case "xl":
          return 6;
      }
    },
  },
  props: {
    products: Array,
    title: String,
  },
};
</script>

<style scoped>
.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  display: none;
  pointer-events: auto;
}

.swiper-button-next {
  color: var(--color-white);
  background-color: var(--v-primary-base);
  border-radius: 50%;
  height: 55px;
  /*pointer-events: none;*/
  right: 0;
  width: 55px;
  z-index: 0;
}
.swiper-button-next:after {
  font-size: 20px;
}
.swiper-button-prev {
  color: var(--color-white);
  background-color: var(--v-primary-base);
  border-radius: 50%;
  height: 55px;
  left: 0;
  width: 55px;
  z-index: 0;
}
.swiper-button-prev:after {
  font-size: 20px;
}
</style>
